import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64073308"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "chats"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "chatBtn" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { id: "bottom" }
const _hoisted_7 = {
  key: 0,
  class: "money"
}
const _hoisted_8 = { id: "main" }
const _hoisted_9 = { class: "img" }
const _hoisted_10 = {
  key: 0,
  class: "system"
}
const _hoisted_11 = {
  key: 1,
  class: "user"
}
const _hoisted_12 = {
  key: 2,
  class: "ai"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  id: "stretch"
}
const _hoisted_15 = { class: "img" }
const _hoisted_16 = {
  key: 0,
  class: "system"
}
const _hoisted_17 = {
  key: 1,
  class: "user"
}
const _hoisted_18 = {
  key: 2,
  class: "ai"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "links"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 0,
  id: "stretch"
}
const _hoisted_23 = {
  key: 2,
  id: "home"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "🤪 N0tsChat | 免费 AI 对话工具"),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 本项目完全开源，无需担心隐私问题，所有聊天记录均保存在本地 "),
    /*#__PURE__*/_createElementVNode("p", null, "解决无法访问外网痛点，导致无法使用 AI 对话"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 开源地址（求 star）："),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://gitee.com/n0ts/chat-gpt",
        target: "_blank"
      }, "Gitee")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 技术交流："),
      /*#__PURE__*/_createElementVNode("a", { href: "https://jq.qq.com/?_wv=1027&k=Mh7ah6Dd" }, "坚果小栈")
    ])
  ])
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  id: "input"
}
const _hoisted_27 = { class: "textarea" }
const _hoisted_28 = { class: "btns" }
const _hoisted_29 = { class: "questions" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请在下方输入你的 GPT Key", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 申请地址："),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://platform.openai.com/account/api-keys",
    target: "_blank"
  }, "点我")
], -1))
const _hoisted_33 = ["onKeydown"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, " key 会保存在本地浏览器(localStorage)中，只供本地使用 ", -1))
const _hoisted_35 = { class: "panel" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "API：", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "GPT Key：", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "OpenAI 申请的 Key", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Model：", -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "ChatGPT 模型选择", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "行为设定：", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("span", null, "给 OpenAI 设定一个行为，比如："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "“你是一直猫，每句话后面加个 喵~”")
], -1))
const _hoisted_44 = ["onKeydown"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "修改当前对话窗口的标题", -1))

import { ref, reactive, onMounted, nextTick, watch } from "vue";
import axios from "axios";
import DialogCom from "@/components/dialogCom.vue";
import messageUtil from "@/utils/messageUtil";
import hljs from "highlight.js";
import Clipboard from "clipboard";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import themeUtil from "@/utils/themeUtil";
import cacheUtil from "@/utils/cacheUtil";
import MarkdownIt from "markdown-it";
import mk from "@iktakahiro/markdown-it-katex";
import pdfUtil from "@/utils/pdf";

interface IMessage {
    role: "user" | "assistant" | "system";
    content: string;
    tokens: number;
    stream: string;
}

// 回话列表
interface IClient {
    name: string;
    contents: Array<IMessage>;
    exceedTokens: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { config, read, save } = cacheUtil;

const backupConfig = JSON.parse(JSON.stringify(config));

// 读取配置
read();

// const apiBaseUrl = ref("");
// if (config.apiBaseUrl && config.apiBaseUrl !== "") {
//     apiBaseUrl.value = config.apiBaseUrl;
// } else {
//     apiBaseUrl.value = backupConfig.apiBaseUrl;
// }

const md = new MarkdownIt();
md.use(mk);

// 输入 key dialog
const okKeyDialog = ref(config.key == "");

// 获取聊天窗口 dom
let messageDom: Element | null = null;
// Viewer
let viewer: any = null;

onMounted(() => {
    viewer = new Viewer(document.querySelector("#main") as HTMLElement);
    messageDom = document.querySelector("#messages");
    themeUtil.load();

    if (config.key) {
        getMoeny();
    }
});

/**
 * 确认 key
 */
const confirmKey = ref("");

function okKey() {
    if (confirmKey.value == "") {
        return messageUtil({
            type: "warning",
            content: "key 不能为空"
        });
    }

    config.key = confirmKey.value;
    confirmKey.value = "";
    save();

    okKeyDialog.value = false;
    messageUtil({
        type: "success",
        content: "key 存储成功，开始提问吧"
    });

    getMoeny();
}

function holdKey() {
    okKeyDialog.value = false;
    config.key = "暂无配置";
    save();
    messageUtil({
        type: "warning",
        content: "暂未配置 key，无法使用 ChatGPT"
    });
}

// 是否正在加载
const loading = ref(false);
// 对话机器人
const chatRobot = ref(config.robot);

/**
 * 提交问题
 */
async function submit() {
    loading.value = true;

    let messages: IMessage[] = [];

    if (chatRobot.value == "chatgpt") {
        const clientCache = clients[clientsIndex.value].contents;
        const lastClientCache = clientCache[clientCache.length - 1];
        if (lastClientCache.role != "assistant") pushResult("assistant", "");

        let cacheSystemClient: IMessage | null = null;
        if (clientCache[0].role == "system") {
            cacheSystemClient = clientCache[0];
        }
        messages = clientCache.slice(
            clients[clientsIndex.value].exceedTokens * 2
        );
        if (cacheSystemClient) {
            messages.unshift(cacheSystemClient);
        }
    }

    if (chatRobot.value == "chatgpt") {
        chatgpt(messages);
    } else {
        newBing();
    }
}

function chatgpt(messages: IMessage[]) {
    fetch(`${config.apiBaseUrl}/v1/chat/completions`, {
        method: "POST",
        body: JSON.stringify({
            model: config.model,
            messages: messages
                .map((item) => {
                    if (!item.content) return;
                    return {
                        role: item.role,
                        content: item.stream
                    };
                })
                .filter(Boolean),
            stream: true
        }),
        headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + config.key
        }
    })
        .then((res: any) => {
            const reader = res.body.getReader();
            const decoder = new TextDecoder("utf-8");
            let streamCache = "";

            reader.read().then(async function processText(res: any) {
                if (res.done || !loading.value) {
                    return;
                }

                const decodeContent = decoder.decode(res.value);

                // error
                if (decodeContent.includes(`"error": {\n`)) {
                    loading.value = false;
                    return errorHandle(decodeContent);
                }

                decodeContent
                    .replaceAll("data: ", "")
                    .split("\n")
                    .filter(Boolean)
                    .forEach(async (item: string) => {
                        // done
                        if (item == "[DONE]") {
                            loading.value = false;
                            const client =
                                clients[clientsIndex.value].contents[
                                    clients[clientsIndex.value].contents
                                        .length - 1
                                ];
                            client.tokens = await computedToken(client.content);

                            saveMessage();
                            await nextTick();
                            hljsInit();
                            viewer.update();
                            return;
                        }

                        const itemObj = JSON.parse(item);
                        if (!itemObj.choices[0].delta.content) {
                            return;
                        }

                        const str = itemObj.choices[0].delta.content;

                        streamCache += str;

                        clients[clientsIndex.value].contents[
                            clients[clientsIndex.value].contents.length - 1
                        ].content = md.render(streamCache);
                        clients[clientsIndex.value].contents[
                            clients[clientsIndex.value].contents.length - 1
                        ].stream = streamCache;
                        await nextTick();
                        hljsInit();
                    });

                return reader.read().then(processText);
            });
        })
        .catch(() => {
            clients[clientsIndex.value].contents[
                clients[clientsIndex.value].contents.length - 1
            ].content =
                "<p>发起网络请求失败，服务器可能正在维护中，请稍后重试</p>";
            messageUtil({
                type: "danger",
                content: "发起网络请求失败，请稍后重试"
            });
            saveMessage();
            loading.value = false;
        });
}

/**
 * 存入数据
 */
async function pushResult(
    role: "user" | "assistant" | "system",
    content: string,
    errContent?: string
) {
    const resultContent = errContent ? errContent : content;
    const contentData = {
        role,
        content: md.render(resultContent),
        tokens: 0,
        stream: resultContent
    };
    if (chatRobot.value == "chatgpt") {
        clients[clientsIndex.value].contents.push(contentData);
    } else {
        newBingClient.value.contents.push(contentData);
    }

    // contentData.tokens = await computedToken(contentData.stream);
    saveMessage();
    await nextTick();
    hljsInit();
    viewer.update();
}

/**
 * 保存会话
 */
function saveMessage() {
    window.localStorage.setItem("message-data", JSON.stringify(clients));
    // tokensCount();
}

// 消息框内容
const message = ref("");

/**
 * 发送消息
 */
function send() {
    // 检验为空不处理
    if (message.value == "" || message.value.trim() == "" || loading.value) {
        return;
    }

    // 没有对话时
    if (chatRobot.value == "chatgpt" && clientsIndex.value == -1) {
        clients.unshift({
            name: "",
            contents: [],
            exceedTokens: 0
        });
        clientsIndex.value = 0;
    }

    // 是否设置了行为
    if (
        chatRobot.value == "chatgpt" &&
        config.system &&
        clients[clientsIndex.value].contents.length == 0
    ) {
        pushResult("system", config.system);
    }

    pushResult("user", message.value);

    // 第一句对话修改标题
    if (
        chatRobot.value == "chatgpt" &&
        (clients[clientsIndex.value].contents.length == 1 ||
            (clients[clientsIndex.value].contents[0].role == "system" &&
                clients[clientsIndex.value].contents.length == 2))
    ) {
        if (chatRobot.value == "chatgpt") {
            const cacheName = message.value;
            let num = 1;
            clients.forEach((item) => {
                if (item.name.indexOf(cacheName) == 0) {
                    num++;
                }
            });
            clients[clientsIndex.value].name =
                cacheName + (num == 1 ? "" : ` #${num}`);
            document.title = cacheName + " | 🤪N0tsChat";
        }
    }

    // 清空输入框
    message.value = "";

    submit();
}

/**
 * 滚动到底部
 */
let scrollLock = false;

function scrollToBottom() {
    if (scrollLock) {
        return;
    }
    scrollLock = true;
    setTimeout(() => {
        scrollLock = false;
        messageDom = document.querySelector("#messages");
        if (messageDom) {
            // const childrens = messageDom.children;
            // let height = 0;
            // if (childrens[childrens.length - 1]) {
            //     height += childrens[childrens.length - 1].clientHeight;
            // }
            // if (childrens[childrens.length - 2]) {
            //     height += childrens[childrens.length - 2].clientHeight;
            // }
            messageDom.scrollTo({
                top: messageDom.scrollHeight,
                behavior: "smooth"
            });
        } else {
            scrollToBottom();
        }
    }, 300);
}

// shift 是否按住
let shiftDown = false;

/**
 * 消息框键盘按下
 */
function keydown(event: KeyboardEvent) {
    // shift 是否按下
    if (event.keyCode === 16) {
        shiftDown = true;
    }
    // shift 不按住与 enter 按下，则发送
    if (!shiftDown && event.keyCode === 13) {
        send();
        event.preventDefault();
        return false;
    }
}

/**
 * 消息框键盘抬起
 */
function keyup(event: KeyboardEvent) {
    // shift 是否取消按下
    if (event.keyCode === 16) {
        shiftDown = false;
    }
}

// 消息框高度
const textareaHeight = ref(24);

// 监听消息框内容变化改变高度
watch(
    () => message.value,
    () => {
        // 根据换行符计算高度
        const lines = message.value.split("\n").length;
        textareaHeight.value = lines * 24;
    }
);

// 消息列表
const cacheClients = window.localStorage.getItem("message-data");
const clients: Array<IClient> = reactive(
    cacheClients ? JSON.parse(cacheClients) : []
);
const clientsIndex = ref(-1);

// 会话索引切换
watch(
    () => clientsIndex.value,
    async () => {
        if (clients[clientsIndex.value]) {
            document.title = clients[clientsIndex.value].name + " | 🤪N0tsChat";
            await nextTick();
            tokensCount();
            hljsInit();
            viewer.update();
            // MathJax.TypeSet();
        }
    }
);

/**
 * 创建新会话
 */
function newClient() {
    saveMessage();
    let num = 1;
    clients.forEach((item) => {
        if (item.name.indexOf("新会话") == 0) {
            num++;
        }
    });
    clients.unshift({
        name: "新会话" + (num == 1 ? "" : ` #${num}`),
        contents: [],
        exceedTokens: 0
    });
    message.value = "";
    clientsIndex.value = 0;
}

/**
 * 删除会话
 */
function removeClient(i: number) {
    // 删除会话
    document.title = "🤪N0tsChat";
    clients.splice(i, 1);
    clientsIndex.value = -1;
    saveMessage();
}

/**
 * 代码高亮
 */
async function hljsInit() {
    const dom: any = [];
    const codeBlocks = document.querySelectorAll("#messages pre code");
    codeBlocks.forEach((cache) => {
        const item = cache as HTMLElement;
        if (item.getAttribute("class")?.includes("hljs")) {
            return;
        }
        const copyBtn = document.createElement("div");
        copyBtn.className = "copyBtn";
        copyBtn.innerHTML = "复制";
        copyBtn.setAttribute("code", item.innerText);
        copyBtn.addEventListener("click", (e) => {
            copyCode(e);
        });
        item.parentElement?.appendChild(copyBtn);
        hljs.highlightElement(item as HTMLElement);
        dom.push(item);
    });
    addCodeNum(dom);
    scrollToBottom();
}

/**
 * 添加代码行号
 */
function addCodeNum(dom: any) {
    for (let i = 0; i < dom.length; i++) {
        const enter = dom[i].innerHTML.replace(/\n/g, "</li><li>");
        dom[i].innerHTML = `<ol><li>${enter}</li></ol>`.replace(
            "<li></li></ol>",
            "</ol>"
        );
    }
}

// 侧边栏显示
const sideBarShow = ref(false);

/**
 * 复制代码块
 */
function copyCode(el: MouseEvent) {
    const code = (el.target as HTMLElement).getAttribute("code");
    if (code) {
        Clipboard.copy(code);
        messageUtil({
            type: "success",
            content: "复制成功"
        });
    }
}

/**
 * 重置配置
 */
function reloadConfig() {
    window.localStorage.removeItem("message-data");
    window.localStorage.removeItem("n0ts-chatgpt-theme");
    window.localStorage.removeItem("n0ts-chatgpt-config");
    window.location.reload();
}

// 设置显示
const settingShow = ref(false);

/**
 * 确认设定
 */
function toggleSetting() {
    settingShow.value = !settingShow.value;
    save();
    messageUtil({
        type: "success",
        content: "设置已保存"
    });
}

/**
 * 获取余额
 */
const moneyData: any = ref(null);
async function getMoeny() {
    return;
    // const { data } = await axios({
    //     method: "post",
    //     url: `${config.apiBaseUrl}/cors`,
    //     data: {
    //         method: "GET",
    //         url: "https://api.openai.com/dashboard/billing/subscription",
    //         headers: {
    //             authorization: `Bearer ${config.key}`
    //         }
    //     }
    // });
    // moneyData.value = data.data;
    // console.log("🚀 余额数据 | moneyData.value:", moneyData.value);
}

/**
 * 保留两位
 */
function moneyToFixed(num: any, fixed: number) {
    return Number(num.toFixed(fixed));
}

/**
 * 错误处理
 */
function errorHandle(error: string) {
    const errorObj = JSON.parse(
        error.replace("未知错误，请联系站长解决！", "")
    );
    console.error("报错了哥们", errorObj);

    if (errorObj.error.code == "invalid_api_key") {
        messageUtil({
            type: "danger",
            content: "API Key 错误，请重新配置"
        });
        config.key = "";
        save();
        okKeyDialog.value = true;
        return;
    } else if (errorObj.error.code == "context_length_exceeded") {
        // messageUtil({
        //     type: "danger",
        //     content: "会话内容已超出，已自动开启优化"
        // });
        clients[clientsIndex.value].exceedTokens += 1;
        return submit();
    }

    clients[clientsIndex.value].contents[
        clients[clientsIndex.value].contents.length - 1
    ].content = error;
}

/**
 * token 计算
 */
async function computedToken(content: string) {
    return 0;
    // if (!content) {
    //     return 0;
    // }
    // const { data } = await axios({
    //     method: "GET",
    //     url: `${config.apiBaseUrl}/chatgpt/encoder`,
    //     params: {
    //         content
    //     }
    // });
    // if (data.status == 400) {
    //     return 0;
    // }
    // return data.data.tokens / 2;
}

/**
 * tokens 总和
 */
const tokensCountNum = ref(0);

function tokensCount() {
    if (!clients[clientsIndex.value]) {
        return;
    }
    let count = 0;
    clients[clientsIndex.value].contents.forEach((item) => {
        count += item.tokens;
    });
    tokensCountNum.value = count;
}

/**
 * 停止回复
 */
function stopMessage() {
    loading.value = false;

    // newbing 处理
    if (chatRobot.value == "newbing") {
        ws.close();
    }
}

/**
 * 导出 pdf
 */
const exportLoading = ref(false);
async function exportPdf() {
    exportLoading.value = true;
    await nextTick();
    await pdfUtil(
        "对话导出 | " +
            new Date().toLocaleDateString().replaceAll("/", "-").toString(),
        "#main"
    );
    messageUtil({
        type: "success",
        content: "正在导出中，耐心稍等一会~"
    });
    exportLoading.value = false;
}

function changeRobot() {
    config.robot = chatRobot.value =
        chatRobot.value == "chatgpt" ? "newbing" : "chatgpt";
    save();
}

const newBingKey = ref<any>(null);
async function getNewBingKey() {
    if (newBingKey.value) {
        return newBingKey.value;
    }
    const { data } = await axios.post(`${config.apiBaseUrl}/bing/new`, {
        cookie: config.nbCookie
    });
    newBingKey.value = data.data;
    return newBingKey.value;
}

let isStartOfSession = true;
const question = ref<any>([]);
const nbLinks = ref<any>([]);
const nbQuestions = ref<any>([]);
const newBingClient = ref<IClient>({
    name: "newbing",
    contents: [],
    exceedTokens: 0
});
let ws: any = null;
async function newBing() {
    if (!config.nbCookie) {
        reloadNewBing(true);
        return messageUtil({
            type: "danger",
            content: "请在配置中填写 Bing Cookie 后使用"
        });
    }

    nbQuestions.value = [];

    const messages = newBingClient.value.contents;
    // 插入回复
    messages.push({
        role: "assistant",
        content: "",
        tokens: 0,
        stream: ""
    });
    const meMsg = messages[messages.length - 2];
    const botMsg = messages[messages.length - 1];

    let ids = await getNewBingKey();

    ws = new WebSocket("wss://api.n0ts.top/newbing");

    ws.onopen = () => {
        console.log("NewBing Ws Open，Content：" + meMsg.stream);
        ws.send(
            JSON.stringify({
                text: meMsg.stream,
                isStartOfSession,
                ...ids
            })
        );
        isStartOfSession = false;
    };

    ws.onmessage = async (e: MessageEvent) => {
        try {
            const cache = JSON.parse(e.data);
            if (cache.question || cache.links) {
                question.value = cache;
            }
        } catch {
            console.log(e.data);
            botMsg.content = md.render((botMsg.stream = e.data));
            await nextTick();
            hljsInit();
        }
    };

    ws.onclose = async () => {
        console.log("NewBing Ws Close");
        loading.value = false;
        saveMessage();
        await nextTick();
        hljsInit();
        viewer.update();

        nbLinks.value = question.value.links;
        nbQuestions.value = question.value.question;
        console.log(question.value);
        console.log("相关链接", nbLinks.value);
        console.log("相关问题", nbQuestions.value);
    };
}

/**
 * 获取当前 AI
 */
function getNowAI() {
    if (chatRobot.value == "chatgpt") {
        return "ChatGPT";
    } else {
        return "NewBing";
    }
}

/**
 * NewBing 重载会话
 */
function reloadNewBing(tipClose?: boolean) {
    newBingClient.value.contents = [];
    newBingKey.value = null;
    ws = null;
    isStartOfSession = true;
    loading.value = false;
    nbLinks.value = [];
    nbQuestions.value = [];
    if (tipClose) return;
    messageUtil({
        type: "success",
        content: "对话重载成功"
    });
}

/**
 * 问题点击
 */
function clickQuestion(item: any) {
    message.value = item.text;
    nbQuestions.value = [];
    send();
}

/**
 * 喝咖啡
 */
function openSupport() {
    window.open("https://support.n0ts.top/");
}

const chatTitleDialogShow = ref(false);
const chatTitle = ref<IClient>();
/**
 * 修改会话标题
 */
function updateChatTitle() {
    saveMessage();
    chatTitleDialogShow.value = false;
    messageUtil({
        type: "success",
        content: "修改标题成功"
    });
}

/**
 * 打开修改会话标题
 */
function openChatTitleDialog(client: IClient) {
    chatTitle.value = client;
    chatTitleDialogShow.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "chatgpt",
      class: _normalizeClass({ print: exportLoading.value })
    }, [
      (!exportLoading.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "sidebar",
            class: _normalizeClass({ sideBarShow: sideBarShow.value })
          }, [
            _createElementVNode("div", { class: "btns" }, [
              _createElementVNode("div", {
                class: "btn",
                onClick: newClient
              }, "🤓 新建会话")
            ]),
            (!exportLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      onClick: ($event: any) => (clientsIndex.value = index),
                      class: _normalizeClass({ active: clientsIndex.value == index })
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", {
                          class: "update",
                          onClick: _withModifiers(($event: any) => (openChatTitleDialog(item)), ["stop"])
                        }, "编辑", 8, _hoisted_4),
                        _createElementVNode("span", {
                          class: "remove",
                          onClick: _withModifiers(($event: any) => (removeClient(index)), ["stop"])
                        }, "删除", 8, _hoisted_5)
                      ])
                    ], 10, _hoisted_2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(themeUtil).switchTheme && _unref(themeUtil).switchTheme(...args)))
              }, _toDisplayString(_unref(themeUtil).themeCache.value == "light"
                            ? "🌃 暗色模式"
                            : "🌇 亮色模式"), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (settingShow.value = true))
              }, "👐 打开配置"),
              _createElementVNode("div", {
                class: "btn",
                onClick: reloadConfig
              }, "👊 重置配置"),
              _createElementVNode("div", {
                class: "btn",
                onClick: openSupport
              }, "☕️ 支持我"),
              (moneyData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 余额：" + _toDisplayString(moneyToFixed(moneyData.value.soft_limit_usd, 2)) + " $，已用：" + _toDisplayString(moneyToFixed(
                            moneyData.value.system_hard_limit_usd -
                                moneyData.value.soft_limit_usd,
                            2
                        )) + " $ ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              id: "showBtn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sideBarShow.value = !sideBarShow.value))
            }, _toDisplayString(sideBarShow.value ? "👈" : "👉"), 1)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (chatRobot.value == 'chatgpt' && clients[clientsIndex.value])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "messages",
              class: _normalizeClass({ print: exportLoading.value })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients[clientsIndex.value].contents, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(item.role == 'user' ? 'right' : 'left')
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (item.role == 'system')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " SY "))
                      : (item.role == 'user')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Me "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(config).robot == "chatgpt" ? "GPT" : "Bing"), 1))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["content", {
                            end:
                                !loading.value ||
                                index !=
                                    clients[clientsIndex.value].contents.length - 1
                        }]),
                    innerHTML: item.content
                  }, null, 10, _hoisted_13)
                ], 2))
              }), 128)),
              (!exportLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true)
            ], 2))
          : (chatRobot.value == 'newbing')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: "messages",
                class: _normalizeClass({ print: exportLoading.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newBingClient.value.contents, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(item.role == 'user' ? 'right' : 'left')
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      (item.role == 'system')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " SY "))
                        : (item.role == 'user')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Me "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(config).robot == "chatgpt" ? "GPT" : "Bing"), 1))
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["content", {
                            end:
                                !loading.value ||
                                index != newBingClient.value.contents.length - 1
                        }]),
                      innerHTML: item.content
                    }, null, 10, _hoisted_19),
                    (
                            index == newBingClient.value.contents.length - 1 &&
                            !loading.value
                        )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nbLinks.value, (item1, index1) => {
                            return (_openBlock(), _createElementBlock("a", {
                              href: item1.seeMoreUrl,
                              target: "_blank",
                              key: index1
                            }, "🔗 " + _toDisplayString(item1.providerDisplayName), 9, _hoisted_21))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                (!exportLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                  : _createCommentVNode("", true)
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25)),
        (!exportLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", {
                class: _normalizeClass(["stop", { stopShow: loading.value }]),
                onClick: stopMessage
              }, " 停止回复 🛑 ", 2),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", { onClick: exportPdf }, "📄 导出PDF"),
                  (chatRobot.value == 'newbing')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (reloadNewBing(false)))
                      }, " 🔃 重载对话 "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nbQuestions.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      onClick: ($event: any) => (clickQuestion(item))
                    }, " ❓ " + _toDisplayString(item.text), 9, _hoisted_30))
                  }), 128))
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((message).value = $event)),
                  onKeydown: keydown,
                  onKeyup: keyup,
                  style: _normalizeStyle({ height: textareaHeight.value + 'px' })
                }, null, 36), [
                  [_vModelText, message.value]
                ])
              ]),
              _createElementVNode("p", null, " 当前 AI：" + _toDisplayString(getNowAI()) + " | 当前 Model：" + _toDisplayString(_unref(config).model), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(DialogCom, {
      title: "初次配置",
      show: okKeyDialog.value
    }, {
      center: _withCtx(() => [
        _hoisted_31,
        _hoisted_32,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confirmKey).value = $event)),
          onKeydown: _withKeys(okKey, ["enter"])
        }, null, 40, _hoisted_33), [
          [_vModelText, confirmKey.value]
        ]),
        _hoisted_34
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("button", {
          class: "success",
          onClick: okKey
        }, "存储"),
        _createElementVNode("button", {
          class: "info",
          onClick: holdKey
        }, "跳过")
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(DialogCom, {
      title: "设置",
      show: settingShow.value
    }, {
      center: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", null, [
            _hoisted_36,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(config).apiBaseUrl) = $event))
            }, null, 512), [
              [_vModelText, _unref(config).apiBaseUrl]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_37,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(config).key) = $event))
            }, null, 512), [
              [_vModelText, _unref(config).key]
            ])
          ]),
          _hoisted_38,
          _createElementVNode("div", null, [
            _hoisted_39,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(config).model) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).models, (item, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_40))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(config).model]
            ])
          ]),
          _hoisted_41,
          _createElementVNode("div", null, [
            _hoisted_42,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(config).system) = $event))
            }, null, 512), [
              [_vModelText, _unref(config).system]
            ])
          ]),
          _hoisted_43
        ])
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("button", {
          class: "success",
          onClick: toggleSetting
        }, "保存"),
        _createElementVNode("button", {
          class: "info",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (settingShow.value = !settingShow.value))
        }, " 关闭 ")
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(DialogCom, {
      title: "修改对话标题",
      show: chatTitleDialogShow.value
    }, {
      center: _withCtx(() => [
        (chatTitle.value)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((chatTitle.value.name) = $event)),
              onKeydown: _withKeys(updateChatTitle, ["enter"])
            }, null, 40, _hoisted_44)), [
              [_vModelText, chatTitle.value.name]
            ])
          : _createCommentVNode("", true),
        _hoisted_45
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("button", {
          class: "success",
          onClick: updateChatTitle
        }, "保存"),
        _createElementVNode("button", {
          class: "info",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (chatTitleDialogShow.value = false))
        }, " 取消 ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})